var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAiBubble = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_8176_1485)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C10.251 5 10.4545 5.20351 10.4545 5.45455C10.4545 7.71389 12.2861 9.54545 14.5455 9.54545C14.7965 9.54545 15 9.74896 15 10C15 10.251 14.7965 10.4545 14.5455 10.4545C12.2861 10.4545 10.4545 12.2861 10.4545 14.5455C10.4545 14.7965 10.251 15 10 15C9.74896 15 9.54545 14.7965 9.54545 14.5455C9.54545 12.2861 7.71389 10.4545 5.45455 10.4545C5.20351 10.4545 5 10.251 5 10C5 9.74896 5.20351 9.54545 5.45455 9.54545C7.71389 9.54545 9.54545 7.71389 9.54545 5.45455C9.54545 5.20351 9.74896 5 10 5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8176_1485",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FA572"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAiBubble);
export default ForwardRef;